import { Component, ElementRef, HostListener, inject, signal } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent {
  private readonly authService = inject(AuthService);
  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);

  readonly menuOpen = signal(false);
  readonly navOpen = signal(false);
  readonly userName$ = this.authService.userName$;
  readonly isAdmin = this.authService.hasAdminPreference();

  initials(name: string | null): string {
    const local = (name ?? '').split('@')[0];
    const parts = local.split(/[\s._-]+/).filter(Boolean);
    const letters = parts.length > 1 ? parts[0][0] + parts[1][0] : local.slice(0, 2);
    return letters.toUpperCase() || '?';
  }

  toggleMenu(event: Event) {
    event.stopPropagation();
    this.navOpen.set(false);
    this.menuOpen.update((open) => !open);
  }

  toggleNav(event: Event) {
    event.stopPropagation();
    this.menuOpen.set(false);
    this.navOpen.update((open) => !open);
  }

  closeAll() {
    this.menuOpen.set(false);
    this.navOpen.set(false);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    if (!this.host.nativeElement.contains(event.target as Node)) this.closeAll();
  }

  @HostListener('document:keydown.escape')
  onEscape() {
    this.closeAll();
  }

  logout() {
    this.closeAll();
    this.authService.logout();
  }
}
